import { clearSlashes, isFirstLevel, isRootPopular } from '@app/services/utils';

const DefaultTitle = 'Портал госуслуг Москвы';

export interface IMetaParams {
  uslugi: {
    [key: string]: string;
  };
  biznes: {
    [key: string]: string;
  };
}

const paramsDefault: IMetaParams = {
  uslugi: {
    title: 'Госуслуги Москвы / Портал госуслуг Москвы',
    description:
      'Госуслуги Москвы: от записи к врачу до регистрации автомобиля — на портале mos.ru создан единый каталог всех муниципальных и региональных госуслуг, которые можно получить на сайте Мэра и Правительства Москвы',
    keywords:
      'госуслуги, портал госуслуг москвы, госуслуги москва, мосгосуслуги, мосуслуги, госпортал москвы, портал госуслуг, госуслуги личный кабинет, сайт госуслуг москвы, сайт госуслуг, госпортал',
    'og:title': 'Каталог госуслуг для жителей Москвы',
    'og:description':
      'Госуслуги Москвы: от записи к врачу до регистрации автомобиля — на портале mos.ru создан единый каталог всех муниципальных и региональных госуслуг, которые можно получить на сайте Мэра и Правительства Москвы',
    'og:image': 'https://www.mos.ru/open-graph/v1/frontend/uslugi/',
  },
  biznes: {
    title: 'Каталог услуг для бизнеса / Портал госуслуг Москвы',
    description:
      'Услуги и сервисы для удобного ведения своего дела в Москве. Регистрация бизнеса, разрешение на таксомоторную деятельность и другие услуги, которые вы можете получить онлайн на сайте Мэра и Правительства Москвы mos.ru',
    keywords:
      'госуслуги для бизнеса, услуги для бизнеса, услуги для бизнеса в москве',
    'og:title': 'Каталог услуг для бизнеса',
    'og:description':
      'Услуги и сервисы для удобного ведения своего дела в Москве. Регистрация бизнеса, разрешение на таксомоторную деятельность и другие услуги, которые вы можете получить онлайн на сайте Мэра и Правительства Москвы mos.ru',
    'og:image': 'https://www.mos.ru/open-graph/v1/frontend/biznes/',
  },
};

function setCanonical(url: string) {
  if (document.querySelector('link[rel="canonical"]')) {
    document.querySelector('link[rel="canonical"]')!.setAttribute('href', url);
  } else {
    let canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    canonical.setAttribute('href', url);
    document.head.appendChild(canonical);
  }
}

function getParams(levelCategories: any[], catalogueType: 'biznes' | 'uslugi') {
  let categoryNames = levelCategories.map((item) => item.title);
  let reversedCategoryNames = categoryNames.reverse();
  // categoryNames.reverse();
  let params = {
    title: '',
    description: '',
    keywords: '',
    'og:title': '',
    'og:description': '',
    'og:url': '',
    'og:image': 'https://www.mos.ru/open-graph/v1/frontend',
  };

  let pathname = clearSlashes(window.location.pathname);

  let isGlobal =
    isFirstLevel(window.location.pathname) ||
    isRootPopular(window.location.pathname);

  makeJson(levelCategories);

  if (isGlobal) {
    paramsDefault[catalogueType]['og:url'] = `${window.location.protocol}//${
      window.location.hostname
    }/${pathname.split('/')[0]}/`;
    setCanonical(paramsDefault[catalogueType]['og:url']);
    return paramsDefault[catalogueType];
  } else {
    if (document.querySelector('link[rel="canonical"]')) {
      let canonical = document.querySelector('link[rel="canonical"]');
      canonical!.parentNode!.removeChild(canonical!);
    }
  }

  params.title = reversedCategoryNames.join(' / ') + ` / ${DefaultTitle}`;
  params.description = reversedCategoryNames.join('. ') + `. ${DefaultTitle}`;
  params.keywords = (
    reversedCategoryNames.join(', ') + `, ${DefaultTitle}`
  ).toLowerCase();
  params['og:title'] = params['og:description'] = categoryNames[0];
  params['og:image'] = params['og:image'] + window.location.pathname;
  params['og:url'] = isGlobal ? pathname.split('/')[0] : window.location.href;

  return params;
}

function makeJson(categories: any[]) {
  function createJsonForItem(index: number, name: string, url: string) {
    if (
      isFirstLevel(window.location.pathname) ||
      isRootPopular(window.location.pathname)
    ) {
      url = `${window.location.protocol}//${window.location.hostname}/${
        clearSlashes(window.location.pathname).split('/')[0]
      }/`;
    } else {
      url = `${window.location.protocol}//${window.location.hostname}${url}`;
    }
    return {
      '@type': 'ListItem',
      position: index,
      name: name,
      item: url,
    };
  }

  if (document.getElementById('breadcrumbList')) {
    let canonical = document.getElementById('breadcrumbList');
    canonical!.parentNode!.removeChild(canonical!);
  }

  let script = document.createElement('script');
  script.setAttribute('type', 'application/ld+json');
  script.setAttribute('id', 'breadcrumbList');
  let itemListElement = categories.map((item, index) => {
    return createJsonForItem(index + 1, item.title, item.routePath);
  });
  let json = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
  };
  script.innerText = JSON.stringify(json);
  document.head.appendChild(script);
}

export function setMeta(data: {
  levelCategories: any[];
  catalogueType: 'biznes' | 'uslugi';
  routePathName: string;
}) {
  let params = getParams(data.levelCategories, data.catalogueType);
  document.title = params.title;
  document
    .querySelector('meta[name="description"]')!
    .setAttribute('content', params.description);
  document
    .querySelector('meta[name="keywords"]')!
    .setAttribute('content', params.keywords);
  document
    .querySelector('meta[property="og:title"]')!
    .setAttribute('content', params['og:title']);
  document
    .querySelector('meta[property="og:description"]')!
    .setAttribute('content', params['og:description']);
  document
    .querySelector('meta[property="og:image"]')!
    .setAttribute('content', params['og:image']);
  document
    .querySelector('meta[property="og:url"]')!
    .setAttribute('content', params['og:url']);
}
